/**
 * 获取transferRelation：dataType和transferType的关联配置
 * @param {Array} dic 字典 iot_transfer_type_show
 * @return {Array} ret [{types:[dataType],values:[transferType]}]
 */
export function getTransferRelation(dic) {
  return dic.map(item => ({
    types: [item.name],
    values: item.value.split(',')
  }));
}

/**
 * iot_transfer_expression_widget 的字典值转为配置
 * @param {String} str 例：Long:1,2
 * @return {Object} ret {Long:"1,2"}
 */
export function strToConfig(str) {
  const arr = str.split(';');
  const ret = {};
  arr.forEach((i) => {
    if (!i) {
      return;
    }
    const temp = i.split(':');
    ret[temp[0]] = temp[1];
  });
  return ret;
}

/**
 * 获取showSetting显示配置
 * @param {Array} dic 字典 iot_transfer_expression_widget
 * @return {Object} ret {Long:"1,2"}
 */
export function getShowSettingConfig(dic) {
  const item = dic.find(obj => obj.name === 'Setting');
  return strToConfig(item.value);
}

/**
 * 获取showInput显示配置
 * @param {Array} dic 字典 iot_transfer_expression_widget
 * @return {Object} ret {Long:"1,2"}
 */
export function getShowInputConfig(dic) {
  const item = dic.find(obj => obj.name === 'Textbox');
  return strToConfig(item.value);
}

// 关联物模型-是否显示设置/输入框
export function showRelativeModelConfig(row, config) {
  const values = config[row.dataType];
  if (values) {
    return values.includes(row.transferType);
  }
  return false;
}

export default {};
